import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { isString } from 'lodash';
import { apiClient } from '../../../api/client/axios';
import { showSnackbar } from '../../../store/snackbarSlice';

const mutatePartner = async ({ payload, isEdit }) => {
  if (isEdit) {
    const { data } = await apiClient.put(`/partners/${payload.id}`, payload);
    return data;
  }
  const { data } = await apiClient.post('/partners', payload);
  return data;
};

export const useMutatePartnerHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: mutatePartner,
    onSuccess: (_, variables) => {
      dispatch(showSnackbar({ message: 'Partner saved successfully.' }));
      queryClient.invalidateQueries({ queryKey: ['partners'] });
      if (onSuccess) onSuccess(variables);
    },
    onError: (err) => {
      if (err instanceof AxiosError) {
        if (err.response?.status === 400) {
          setError(err.response.data.errors);
          return;
        }
        dispatch(showSnackbar({ message: err.response?.data?.message || err.message, severity: 'error' }));
        return;
      }
      dispatch(
        showSnackbar({
          message: isString(err?.message) ? err.message : JSON.stringify(err?.message),
          severity: 'error',
        }),
      );
    },
  });

  const onSubmit = async (payload, isEdit) => mutation.mutate({ payload, isEdit });

  return {
    data: mutation.data,
    isError: mutation.isError,
    error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit,
  };
};
